/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lpName: NonNullable<unknown> }} Coinvestments_Contacts_Modal_Title1Inputs */

const en_coinvestments_contacts_modal_title1 = /** @type {(inputs: Coinvestments_Contacts_Modal_Title1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lpName} Contacts`)
};

/**
* | output |
* | --- |
* | "{lpName} Contacts" |
*
* @param {Coinvestments_Contacts_Modal_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_contacts_modal_title1 = /** @type {((inputs: Coinvestments_Contacts_Modal_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Contacts_Modal_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_contacts_modal_title1(inputs)
});
export { coinvestments_contacts_modal_title1 as "coInvestments_contacts_modal_title" }